/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkdescription2Inputs */

const en_profilelinkdescription2 = /** @type {(inputs: Profilelinkdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected profiles get new requests as notifications on their phone and can accept them right in the app.`)
};

const de_profilelinkdescription2 = /** @type {(inputs: Profilelinkdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbundene Profile bekommen neue Anfragen als Mitteilung aufs Handy und können sie direkt in der App annehmen.`)
};

/**
* | output |
* | --- |
* | "Connected profiles get new requests as notifications on their phone and can accept them right in the app." |
*
* @param {Profilelinkdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkdescription2 = /** @type {((inputs?: Profilelinkdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkdescription2(inputs)
	return de_profilelinkdescription2(inputs)
});
export { profilelinkdescription2 as "profileLinkDescription" }